module.exports = __webpack_public_path__ + "b0bf4342035b9145740e1a11adf6f4c8.png";